import React from "react";

import { Loading } from "ui-library/atoms";

import i18n from "core/i18n";
import { InPageHookFormLayout } from "containers/inPageForm";
import { Form, FormErrorBox } from "core/hookForm";
import { useHasRole } from "core/hooks";
import { Roles } from "enums";
import { ChangeSuccessTextType, SignatureType } from "types";

import { FORM_CONTRACT_VEHICLE_SUBJECTS } from "../../constants";

import useVehicleSubjectChangeForm from "./hooks/useVehicleSubjectChangeForm";
import NotFeasible from "./components/NotFeasible";
import StepSubjects from "./components/StepSubjects";
import StepSignature from "./components/StepSignature";
import StepDocuments from "./components/StepDocuments";

export default function VehicleSubjectChangeForm() {
    const { t } = i18n.useTranslation();
    const isAuthenticated = useHasRole(Roles.AUTHENTICATED);

    const { form, signatureType, contractNumber, step, isLoading, isFeasible, vehicles, nextStep, previousStep } =
        useVehicleSubjectChangeForm();

    const successTextType =
        signatureType === SignatureType.ELECTRONIC && !isAuthenticated
            ? ChangeSuccessTextType.SERVICE_HUB_CHANGE_SIGNATURE_BY_EMAIL_PROCESSED
            : ChangeSuccessTextType.SERVICE_HUB_CHANGE_WITH_SIGNATURE_PROCESSED;

    return (
        <Form form={form} onSubmit={null}>
            <InPageHookFormLayout
                formName={FORM_CONTRACT_VEHICLE_SUBJECTS}
                formTitle={t("vehicle.change.subject.title", { contractNumber })}
                isFormSubmitted={step === 4}
                changeSuccessTextType={successTextType}
                showFeedbackSurvey
            >
                <Loading loading={isLoading}>
                    <FormErrorBox />

                    {!isFeasible && <NotFeasible />}

                    {step === 1 && <StepSubjects vehicles={vehicles} nextStep={nextStep} />}
                    {step === 2 && <StepSignature nextStep={nextStep} previousStep={previousStep} />}
                    {step === 3 && <StepDocuments nextStep={nextStep} />}
                </Loading>
            </InPageHookFormLayout>
        </Form>
    );
}
